import { EVIDENTIAL_DOCS_MATRIX_INTERMEDIARY } from "../../data/evidential_docs_matrix_intermediary.data";

export const RESOURCE_LINK_ITEMS = {
  Customers: [
    {
      title: "Foreign Nationals (PDF, 351KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Foreign_Nationals.pdf",
    },
    {
      title: "Overseas Customers (PDF, 642KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Overseas_Customers.pdf",
    },
    {
      title: "Vulnerable customers (PDF, 683KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Vulnerable_customers.pdf",
    },
  ],
  Guides: [
    {
      title: "Additional borrowing (PDF, 1417KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Additional_borrowing.pdf",
    },
    {
      title: "New build useful guide (PDF, 632KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/New_build_useful_guide.pdf",
    },
    {
      title: "Packaging and process (PDF, 624KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/New_build_useful_guide.pdf",
    },
    {
      title: "Packaging and process (PDF, 603KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Packaging_and_process_final.pdf",
    },
    {
      title: "Product switching guide (PDF, 792KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Product_switching.pdf",
    },
    {
      title: "Reasons to use HSBC UK (Residential) (PDF, 808KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Reasons_to_use_HSBC_UK(residential).pdf",
    },
    {
      title: "Remortgage (PDF, 342KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Remortgage.pdf",
    },
  ],
  Risk: [
    {
      title: "Cybercrime made simple (PDF, 717KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Cybercrime_made_simple.pdf",
    },
    {
      title: "Family employment (PDF, 221KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Family_Employment.pdf",
    },
    {
      title: "Fraud bulletin (PDF, 327KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Fraud_bulletin.pdf",
    },
    {
      title: "Risk useful links (PDF, 127KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Risk_useful_links.pdf",
    },
    {
      title: "Second employment (PDF, 203KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Second_Employment.pdf",
    },
    {
      title: "Unconfirmed employment (PDF, 228KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Unconfirmed_Employment.pdf",
    },
  ],
  CritPol: [
    {
      title: "Interest Only (PDF, 482KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Interest_Only.pdf",
    },
  ],
  Income: [
    {
      title: "Employed income (PDF, 657KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Employed_Income.pdf",
    },
  ],
  SpecLanding: [
    {
      title: "Buy to Let (PDF, 474KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Buy_to_Let.pdf",
    },
    {
      title: "Consent to Let (PDF, 532KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Consent_to_Let.pdf",
    },
    {
      title: "International BTL (PDF, 517KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/International_BTL.pdf",
    },
    {
      title: "Utilising rental income (PDF, 429KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Utilising_Rental_Income.pdf",
    },
  ],
  UsefulApp: [
    {
      title: "Application amendment form (PDF, 402KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/ApplicationAmendmentForm-September2026.pdf",
    },
    {
      title: "Application form (PDF, 415KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Application_form.pdf",
    },
    {
      title: "BTL Valuation appeal form (PDF, 115KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/BTL_Valuation_appeal_form.pdf",
    },
    {
      title: "Changes to your registration with HSBC UK (PDF, 74KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Changes_to_your_registration_with_HSBC_UK.pdf",
    },
    {
      title: "Common keying errors (PDF, 634KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Keying_errors.pdf",
    },
    {
      title: "Government Backed Loan Scheme declaration (PDF, 46KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Government_Backed_Loan_Scheme_declaration.pdf",
    },
    {
      title: "High Value Mortgage Service Application Form (PDF, 62KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/High_value_mortgage_service_application_form.pdf",
    },
    {
      title: "International KYC form (PDF, 91KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/KYC_form.pdf",
    },
    {
      title: "Parental leave form (PDF, 33KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Parental_leave_form.pdf",
    },
    {
      title: "Product Selection Guide (PDF, 374KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/ProductSelectionGuide.pdf",
    },
    {
      title: "Residential Valuation appeal form (PDF, 111KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Residential_Valuation_appeal_form.pdf",
    },
    {
      title: "Validating existing customers (PDF, 1016KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Validating_existing_customers_Final.pdf",
    },
  ],
  UsefulCritPol: [
    {
      title: "All about HSBC UK (PDF, 1983KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/AllaboutHSBCUK-Final.pdf",
    },
    {
      title: "BTL & LTB (PDF, 1781KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/BTL_LTB_Useful_Guide_august2026.pdf",
    },
    {
      title: "Country Specific Credit Bureau Matrix (PDF, 37KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Country_Specific_Credit_Bureau_Matrix.pdf",
    },
    {
      title: "Foreign currency matrix (PDF, 384KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/MortgageManualCurrencyUpdateSeptember2026.pdf",
    },
    {
      title: "Interest Only Repayment Plans (PDF, 1034KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Interest-only_repayment_plans_august2026.pdf",
    },
    {
      title: "Interest Only useful guide (PDF, 1120KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Interest_Only_useful_guide_august2026.pdf",
    },
    {
      title: "Overseas customers (PDF, 1152KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Overseas_Customers_Useful_Guide.pdf",
    },
    {
      title: "Residential affordability calculator (PDF, 1631KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Residential-affordability-calculator-Final-1.pdf",
    },
    {
      title: "Self employed (PDF, 2888KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/Self-employed-Final_august2026.pdf",
    },
    {
      title: "Solicitor Additional Fees (PDF, 1425KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/MM_LMS_Optima_Legal_Additional_Service_Price_List27OCT2026_IWS.pdf",
    },
  ],
  UsefulPack: [
    {
      title: "Buy to Let Evidential Documents Matrix (PDF, 651KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/BTL_Evidential_Docs_Matrix_august2026.pdf",
    },
    {
      title: `${EVIDENTIAL_DOCS_MATRIX_INTERMEDIARY.title} (${EVIDENTIAL_DOCS_MATRIX_INTERMEDIARY.file_type}, ${EVIDENTIAL_DOCS_MATRIX_INTERMEDIARY.file_size})`,
      isDownload: true,
      isBlank: true,
      href: EVIDENTIAL_DOCS_MATRIX_INTERMEDIARY.link_href,
    },
    {
      title: "Verifying Identity and Address (PDF, 1865KB)",
      isDownload: true,
      isBlank: true,
      href: "/pdfs/ID_and_VA_july.pdf",
    },
  ],
};

export const RESOURCE_DOWNLOADABLE_ITEMS = [];
